import WorkflowManagement from "../app/modules/adminrh/parametres/parametresJS/WorkflowManagement";
import SkillManagement from "../app/modules/skills/admin/SkillManagement";
import CampagneFormModal from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneFormModal";
import CampagneCompetences from "../app/modules/skills/campagne/CampagneCompetences";
import CareerPathManagement from "../app/modules/skills/admin/CareerPathManagement";
import AutoEval from "../app/modules/skills/collab/AutoEval";
import DashboardSkillsCollab from "../app/modules/skills/collab/DashboardSkillsCollab";
import EvalQUIZ from "../app/modules/skills/collab/EvalQUIZ";
import EvalEquipe from "../app/modules/skills/manager/EvalEquipe";
import DashboardSkillsManager from "../app/modules/skills/manager/DashboardSkillsManager";
import RadarPage from "../app/modules/skills/viz/RadarPage";
import GapPage from "../app/modules/skills/viz/GapPage";
import ManagerGapPage from "../app/modules/skills/manager/ManagerGapPage";
import ManagerRadarPage from "../app/modules/skills/manager/ManagerRadarPage";
import EvalPairs from "../app/modules/skills/collab/EvalPairs";
import {Route} from "react-router-dom";
import React from "react";
import SeuilPassageManagement from "../app/modules/jobs/SeuilPassage/SeuilPassageManagement";
import FormationSkillManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/FormationSkillManagement";

import MonFeedback360 from "../app/modules/skills/collab/MonFeedback360";
import RfRadarPage from "../app/modules/skills/rf/RfRadarPage";
import DashboardSkillsRespo from "../app/modules/skills/rf/DashboardSkillsRespo";
import QuestionManagement from "../app/modules/QuizAndQuestions/QuestionManagement";
import QuizManagement from "../app/modules/QuizAndQuestions/QuizManagement";
import ModuleCleManagement
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/moduleCle/ModuleCleManagement";
import ConsolidationDemandes from "../app/modules/Formation/ResponsableFormation/RessourcesJs/ConsolidationDemandes";
import ConsolidationSkills from "../app/modules/skills/rf/ConsolidationSkills";
import JobDescriptionGenerator from "../app/modules/jobs/JobDescriptionGenerator";

export const SkillsRoutes = [
    { path: "admin/skills", element: <SkillManagement /> },
    { path: "/skills/formations-liaisons", element: <FormationSkillManagement /> },
    { path: "/skills/responsable/campagnes", element: <CampagneCompetences /> },
    { path: "/skills/responsable/campagnes/add", element: <CampagneFormModal /> },
    { path: "/skills/responsable/campagnes/:id/edit", element: <CampagneFormModal /> },
    { path: "/skills/responsable/parcours", element: <CareerPathManagement /> },
    { path: "/skills/collaborateur/dashboard", element: <DashboardSkillsCollab /> },
    { path: "/skills/auto-evaluation", element: <AutoEval /> },
    { path: "/skills/eval-quiz", element: <EvalQUIZ /> },
    { path: "/skills/manager/dashboard", element: <DashboardSkillsManager /> },
    { path: "/skills/eval-equipe", element: <EvalEquipe /> },
    { path: "/skills/eval-n2", element: <EvalEquipe initialTab="n2" /> },
    { path: "/skills/eval-paires", element: <EvalPairs /> },
    { path: "/skills/mes-resultats-360", element: <MonFeedback360 /> },
    { path: "/skills/visualisation/radar", element: <RadarPage /> },
    { path: "/skills/visualisation/ecarts", element: <GapPage /> },
    { path: "/skills/manager/ecarts", element: <ManagerGapPage /> },
    { path: "/skills/manager/radar", element: <ManagerRadarPage /> },
    { path: "/postes/seuils", element: <SeuilPassageManagement />},
    { path: "/parametres/evaluation-360", element: <SkillManagement initialTab="modes" open360OnMount /> },
    { path: "/skills/rf/radar", element: <RfRadarPage /> },
    { path: "/skills/responsable/dashboard", element: <DashboardSkillsRespo /> },
    { path: "/skills/responsable/consolidation", element: <ConsolidationSkills /> },



    { path: "/skills/quizzes/:quizId/questions", element: <QuestionManagement /> },
    { path: "/skills/quizzes", element: <QuizManagement moduleContext="SKILLS" /> },
    { path: "/modulescl", element: <ModuleCleManagement moduleContext="SKILLS" /> },
];
